<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        props: {
            endpoint: String,
        },
        data() {
            return {
                loading: false,
                message: null,
                hasError: false,
                visible: false,
            }
        },
        methods: {
            handleSuccess(formojData) {
                this.loading = true;
                axios.post(this.endpoint, {
                    answer_id: formojData.answer_id,
                })
                .then(response => {
                    this.message = response.data.data.message;
                })
                .catch(() => {
                    this.message = `Une erreur est survenue lors de l'envoi, veuillez réessayer plus tard`;
                    this.hasError = true;
                })
                .finally(() => {
                    this.loading = false;
                });
            },
        },
        mounted() {
            this.visible = location.hash === '#evaluer';
        }
    }
</script>
